import React from "react";

function SvgIcMapPoi017(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M18.546 14l-1.83 3.434L14 12l-4 8h11.997l-3.451-6zM8 22h16V11H8v11zM25.5 8a1.497 1.497 0 01.5 2.908v11.184A1.496 1.496 0 1124.092 24H7.908A1.496 1.496 0 116 22.092V10.908A1.496 1.496 0 117.908 9h16.184c.207-.581.756-1 1.408-1zm-8.646-3.854l3 3a.502.502 0 01-.708.708L16.5 5.207l-2.646 2.647a.502.502 0 01-.708-.708l3-3a.502.502 0 01.708 0z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi017;
